// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "人工智能与计算思维",
      "tec": "姚文亮",
      "week": "7,9,11,13,15周",
      "add": "教学楼A座117电力"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "齐越",
        "week": "6-17周",
        "add": "实训楼E座310"
      },
      {
        "sub": "26电气1-1",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "26电气1-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26电气2-2",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "26电气2-3",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26电气2-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26电气1-2",
        "tec": "张然",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26电气1-4",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "实训楼E座503语音室"
      }
    ],
    0,
    {
      "sub": "军事理论",
      "tec": "黄明",
      "week": "13-18周",
      "add": "教学楼A座222电力"
    },
    0
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "刘丽梅",
      "week": "6-17周",
      "add": "教学楼A座126信息"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "高等数学（一）",
      "tec": "刘丽梅",
      "week": "6-17周",
      "add": "教学楼A座126信息"
    },
    0,
    0,
    [
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "6周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "6周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "7周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "7周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "8周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "8周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "9周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "9周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "10周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "10周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "11周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "11周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "12周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "12周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "13周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "13周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "14周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "14周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "15周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "15周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "16周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "16周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "17周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "健康教育",
        "tec": "张馨元",
        "week": "17周",
        "add": "教学楼C座112教务"
      }
    ],
    0
  ],
  "4": [
    0,
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "姚文亮",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座303"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "姚文亮",
        "week": "7,9,11,13,15周",
        "add": "教学楼A座117电力"
      }
    ],
    [
      {
        "sub": "大学英语（一）",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26电气1-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26电气2-2",
        "tec": "张然",
        "week": "6-17周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "26电气1-4",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "26电气1-2",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26电气2-1",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "26电气2-3",
        "tec": "齐越",
        "week": "6-17周",
        "add": "教学楼A座226电力"
      },
      {
        "sub": "26电气1-1",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "教学楼D座215经管"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "13-16周",
      "add": "大活礼堂"
    }
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "刘丽梅",
      "week": "6-17周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "智能电网信息工程导论",
      "tec": "魏子康",
      "week": "6-13周",
      "add": "教学楼A座320电力"
    },
    0,
    [
      {
        "sub": "形势与政策",
        "tec": "祝嘉悦",
        "week": "6-9周",
        "add": "教学楼C座311教务"
      },
      {
        "sub": "军事理论",
        "tec": "黄明",
        "week": "12,14,16周",
        "add": "教学楼A座226电力"
      }
    ],
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
